var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"500px"}},[_c('van-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }